<template>
  <!-- <hm-content title=""> -->
  <div>
    <div class="bg">
      <div class="flex flex-end mb20 ">
        <el-select
          class="mr10"
          size="small"
          filterable
          v-model="searchCondition.gameType"
          placeholder="请选择活动类型"
          @change="gameTypeChange"
          ref="select0"
        >
          <el-option
            :label="v.gameName"
            :value="v.gameCode"
            :key="i"
            v-for="(v, i) in gameTypeList"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          filterable
          v-model="searchCondition.gameId"
          placeholder="请选择活动名称"
          @change="gameNameChange"
          style="width:280px"
          ref="select1"
        >
          <el-option
            :label="v.gameName"
            :value="v.gameId"
            :key="i"
            v-for="(v, i) in gameNameList"
          ></el-option>
        </el-select>
      </div>
      <div class="flex flex-between">
        <div
          class="act-data p10 flex flex-center flex-1 "
          :class="{ mr20: i < actDataTotal.length - 1 }"
          v-for="(v, i) in actDataTotal"
          :key="i"
        >
          <div class="flex">
            <div class="img mr20">
              <img :src="v.img" alt="" />
            </div>
            <div class="flex flex-column flex-center">
              <div>
                {{ v.name }}
              </div>
              <div class="val">
                {{ v.val }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt20" v-if="searchCondition.gameType === 'subscribe'">
        <el-scrollbar
          ref="scrollbar"
          :vertical="false"
          wrap-style="height: 480px;"
        >
          <div
            v-for="(v, i) in subscribeDetailEchartsList"
            :key="i"
            class="mt20"
          >
            <div class="title">活动地点{{ i + 1 }}:{{ v.actSite }}</div>
            <ve-histogram
              ref="histogram"
              :data="v.chartData"
              :settings="settings"
              :extend="extend"
              :data-empty="dataEmpty"
            ></ve-histogram>
            <div
              class="blue  is-showtip flex flex-center"
              v-if="isShowTip && subscribeDetailEchartsList.length > 1"
            >
              下滑查看更多
              <div>》</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="mt20" v-else>
        <!-- v-if="chartData.rows.length" -->
        <ve-histogram
          ref="histogram"
          :data="chartData"
          :settings="settings"
          :extend="extend"
          :data-empty="dataEmpty"
        ></ve-histogram>
      </div>
    </div>

    <div class="bg mt20">
      <div class="flex flex-end">
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始时间段筛选"
          end-placeholder="结束时间段筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          clearable
          :picker-options="pickerOptions"
          @change="applyDateChange"
        ></el-date-picker>
      </div>
      <ve-line
        ref="veline"
        :data="chartDataLine"
        :settings="settingsLine"
        :extend="extendLine"
      >
      </ve-line>
    </div>
    <div class="bg mt20">
      <div class="mt20 flex flex-between item-center">
        <div class="title">
          数据分析
        </div>
        <div>
          <el-date-picker
              v-model="dataAnalysis"
              type="daterange"
              size="small"
              range-separator="至"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="dataAnalysisChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class="mt20">
        <div class="flex">
          <div class="line-title flex" v-for="(v,i) in statisticsLineTitleData" :key="i">
            <div class="line-border" :class="v.type =='uv' ? 'uv-border' : 'pv-border'"></div>
            <div class="flex flex-center item-center flex-1">
              <div>
                <div class="flex item-center">
                  <div class="title-style">{{ v.title }}</div>
                  <el-tooltip
                      class="tooltip"
                      effect="light"
                      :content="v.desc"
                      placement="top"
                  >
                    <i class="el-icon-question gray" style="font-size: 14px"></i>
                  </el-tooltip>
                </div>
                <div class="text-center val-style">{{ v.val }}</div>
              </div>
            </div>
          </div>
        </div>
        <ve-line
            class="mt20"
            :data="statisticsChartsData"
            :settings="statisticsSettingsLine"
            :extend="statisticsDataZoom"
            :colors="colors"
        >
        </ve-line>
      </div>
    </div>

    <div class="bg mt20">
      <div class="mt40 flex flex-between item-center">
        <div class="title">
          流量来源
        </div>
        <div>
          <el-date-picker
              v-model="dataPathAnalysis"
              type="daterange"
              size="small"
              range-separator="至"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="dataPathAnalysisChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>

      <div class="mt20">
        <div class="flex-1" >
          <div class="box flex" style="width:50%">
            <div class="yuan">
                <span
                    class="hmicon icon-a-shangpinliulianglaiyuanleixingfenxi2x"
                ></span>
            </div>
            <div class="flex flex-1  flex-column flex-around">
              <div class="name">
                商品流量来源类型分析
              </div>
              <div class="content" v-if="trafficList && trafficList.length > 0">
                {{ trafficList[0].pathName ? trafficList[0].pathName : "其他" }}的流量来源占比最高，达到{{
                  trafficList[0].visitPvProportion
                }}%
                 <!--直接退出的流量去向占比最高，达到45.22%-->
              </div>
            </div>
          </div>
          <div class="mt20">
            <el-table
                stripe
                ref="table"
                :data="trafficList"
                style="width: 100%"
                size="small"
            >
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="pathName"
                  label="来源类型"
              >
                <template slot-scope="scope" >
                  {{ scope.row.pathName ? scope.row.pathName : "其他" }}
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuVisitUv"
                  label="访客数"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="ordewddwrSn"
                  label="访客数占比"
              >
                <template slot-scope="scope">
                  <el-progress
                      :percentage="scope.row.visitPvProportion || 0"
                  ></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    </div>

  </div>
  <!-- </hm-content> -->
</template>

<script>
import VeHistogram from "v-charts/lib/histogram.common";
import VeLine from "v-charts/lib/line.common";

export default {
  components: { VeHistogram, VeLine },
  data() {
    return {
      isShowTip: true,
      subscribeDetailEchartsList: [],
      pickerOptions: {
        disabledDate: time => {
          let startdate = new Date(this.disabledStartDate).getTime();
          let enddate = new Date(this.disabledEndDate).getTime();

          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          // let day = 2 * 24 * 3600 * 1000;
          // let dateRegion = curDate + day;
          return time.getTime() < startdate || time.getTime() > enddate;
        }
      },
      dataEmptyLine: false,
      dataEmpty: true,
      extend: {
        legend: {
          // formatter: function(name) {
          //   // 用来格式化图例文本，支持字符串模板和回调函数两种形式。模板变量为图例名称 {name}
          //   console.log(name, "图例名称");
          //   if (name === "奖品发放数量" || name === "中奖数量") {
          //     return name;
          //   } else {
          //     return;
          //   }
          // },
          show: true,
          bottom: "35"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // type:"cross"
            crossStyle: {
              color: "#999"
            }
          }
        },
        // 每个柱子
        series(v) {
          // 设置柱子的样式

          v.forEach(i => {
            i.barWidth = 20;
            i.itemStyle = {
              opacity: 0.67

              // borderWidth: 3.5
            };
          });

          return v;
        },
        xAxis: {
          axisTick: {
            show: true,
            inside: true,
            length: 10
          },
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              if (value.length > 10) {
                let ret = ""; //拼接加\n返回的类目项
                let maxLength = 10; //每项显示文字个数
                let valLength = value.length; //X轴类目项的文字个数
                let rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                if (rowN > 1) {
                  //如果类目项的文字大于3,
                  for (let i = 0; i < rowN; i++) {
                    let temp = ""; //每次截取的字符串
                    let start = i * maxLength; //开始截取的位置
                    let end = start + maxLength; //结束截取的位置
                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + "\n";
                    ret += temp; //凭借最终的字符串
                  }
                  return ret;
                } else {
                  return value;
                }
                // return value.split("").join("\n");
              }

              return value;
            }
          }
        },
        dataZoom: {
          realtime: true, //拖动滚动条时是否动态的更新图表数据
          height: 25, //滚动条高度
          start: 0, //滚动条开始位置（共100等份）
          end: 50 //结束位置（共100等份）
        }
      },
      settings: {
        labelMap: {
          rankingSeqNum: "日期",
          sendCount: "奖品发放数量",
          winningCount: "中奖数量"
        }
      },
      chartData: {
        columns: ["rankingSeqNum", "sendCount", "winningCount"],
        rows: [
          // {
          //   rankingSeqNum: "1/1",
          //   sendCount: 1393,
          //   winningCount: 1093,
          //   userRate: 0.32
          // },
          // {
          //   rankingSeqNum: "1/2",
          //   sendCount: 3530,
          //   winningCount: 3230,
          //   userRate: 0.26
          // },
          // {
          //   rankingSeqNum: "1/3",
          //   sendCount: 2923,
          //   winningCount: 2623,
          //   userRate: 0.76
          // },
          // {
          //   rankingSeqNum: "1/4",
          //   sendCount: 1723,
          //   winningCount: 1423,
          //   userRate: 0.49
          // },
          // {
          //   rankingSeqNum: "1/5",
          //   sendCount: 3792,
          //   winningCount: 3492,
          //   userRate: 0.323
          // },
          // {
          //   rankingSeqNum: "1/6",
          //   sendCount: 4593,
          //   winningCount: 4293,
          //   userRate: 0.78
          // }
        ]
      },
      extendLine: {
        legend: {
          show: true,
          bottom: "bottom"
        },
        xAxis: {
          axisTick: {
            show: true,
            inside: true,
            length: 10
          }
        },
        title: {
          show: true, //show 可以在上面顶一个一个 let show = null;
          textStyle: {
            fontSize: 14,
            fontWeight: 400,
            color: "#888"
          },
          text: "请选择时间段", //这个你可以定义一个变量，也可以直接写死'暂无数据'
          left: "center",
          top: "center"
        }
      },
      showEmpyt: true,
      chartDataLine: {
        columns: ["timeQuantum", "joinCount", "sendCount", "winningCount"],
        rows: [
          // { date: "1/1", userOrder: 1093, userCount: 1393, userRate: 0.32 },
          // { date: "1/2", userOrder: 3530, userCount: 3230, userRate: 0.32 },
          // { date: "1/3", userOrder: 2223, userCount: 1393, userRate: 0.32 },
          // { date: "1/4", userOrder: 1193, userCount: 1423, userRate: 0.32 },
          // { date: "1/5", userOrder: 3333, userCount: 4293, userRate: 0.32 }
          // { date: "1/2", userCount: 3530, userOrder: 3230, userRate: 0.26 },
          // { date: "1/3", userCount: 2923, userOrder: 2623, userRate: 0.76 },
          // { date: "1/4", userCount: 1723, userOrder: 1423, userRate: 0.49 },
          // { date: "1/5", userCount: 3792, userOrder: 3492, userRate: 0.323 },
          // { date: "1/6", userCount: 4593, userOrder: 4293, userRate: 0.78 }
        ]
      },
      settingsLine: {
        labelMap: {
          timeQuantum: "时间",
          joinCount: "参与次数",
          sendCount: "奖品发放数量",
          winningCount: "中奖数量"
        }
        // title: {
        //   text: "暂无数据",
        //   x: "center",
        //   y: "center",
        //   textStyle: {
        //     color: "#fff",
        //     fontWeight: "normal",
        //     fontSize: 16
        //   }
        // }
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        gameType: "turntable",
        applyDate: ""
      },
      gameTypeList: [],
      gameNameList: [],
      turntable: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/participateNum.png",
          name: "参与次数",
          val: 0
        },
        {
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/participateMember.png",
          name: "参与人数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prizeNum.png",
          name: "中奖数量",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prizeMember.png",
          name: "中奖人数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prize.png",
          name: "奖品发放数量",
          val: 0
        }
      ],
      bargain: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/sucessNum.png",
          name: "砍到底价购买数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/notNum.png",
          name: "未砍到底价购买数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/failNum.png",
          name: "参与砍价未购买数",
          val: 0
        }
      ],
      team: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/sucessNum.png",
          name: "已成团数量",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/notNum.png",
          name: "待成团数量",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/failNum.png",
          name: "拼团失败数量",
          val: 0
        }
      ],
      subscribe: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/subscribeCount.png",
          name: "预约数量",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/presentCount.png",
          name: "到场数量",
          val: 0
        },
        {
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/shareSubscribeCount.png",
          name: "通过分享预约数量",
          val: 0
        }
        // {
        //   img:
        //     "https://imgcdn.hemiao100.com/ThemePictures/subscribeVouchersCount.png",
        //   name: "发券数量",
        //   val: 0
        // },
        // {
        //   img:
        //     "https://imgcdn.hemiao100.com/ThemePictures/useVouchersCount.png",
        //   name: "用券数量",
        //   val: 0
        // }
      ],
      actDataTotal: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/participateNum.png",
          name: "参与次数",
          val: 0
        },
        {
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/participateMember.png",
          name: "参与人数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prizeNum.png",
          name: "中奖数量",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prizeMember.png",
          name: "中奖人数",
          val: 0
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/prize.png",
          name: "奖品发放数量",
          val: 0
        }
      ],
      disabledStartDate: "",
      disabledEndDate: "",
      dataAnalysis: "",
      dataPathAnalysis: "",
      statisticsChartsData: {
        columns: ['timeQuantum', 'spuVisitUv', 'visitPv'],
        rows: []
      },
      statisticsSettingsLine: {
        labelMap: {
          timeQuantum: "日期",
          spuVisitUv: "访问人数",
          visitPv: "访问次数"
        }
      },
      statisticsDataZoom: {
        legend: {
          show: true,
          bottom: "bottom"
        }
      },
      colors: ["#43CDB7", "#B33AF7"],
      statisticsLineTitleData: [
        {
          title: "访问人数",
          val: "",
          type: "uv",
          desc: "活动时间段内的访问人数"
        },
        {
          title: "访问次数",
          val: "",
          type: "pv",
          desc: "活动时间段内的访问次数"
        }
      ],
      trafficList: []
    };
  },
  created() {},
  mounted() {
    this.queryGameTypeList();
    this.findStoreGameInfoToGameData();
  },
  methods: {
    applyDateChange() {
      this.queryGameDataTotalEcharts();
    },
    dataAnalysisChange() {
      this.queryGameDataAnalyse();
    },
    dataPathAnalysisChange() {
      this.queryGameDataAnalysePath();
    },
    gameTypeChange(val) {
      this.gameNameList = [];
      this.searchCondition.gameId = "";
      this.actDataTotal = [];
      if (val) {
        if (val.includes("_team")) {
          this.actDataTotal = this.team;
        } else {
          this.actDataTotal = this[val];
        }

        this.findStoreGameInfoToGameData();
      }
      setTimeout(() => {
        this.$refs.select0.blur();
      }, 10);
    },
    gameNameChange(val) {
      if (val) {
        this.queryActInfo();
      }
      setTimeout(() => {
        this.$refs.select1.blur();
      }, 10);
    },
    async queryActInfo() {
      const { result } = await this.$store.dispatch(
        "queryGameDataBoard",
        this.searchCondition
      );
      const { detailEchartsList, totalModel } = result;
      this.dataEmpty = detailEchartsList.length ? false : true;
      if (this.searchCondition.gameType === "turntable") {
        //大转盘
        this.actDataTotal[0].val = totalModel.joinCount;
        this.actDataTotal[1].val = totalModel.joinPeopleCount;
        this.actDataTotal[2].val = totalModel.winningCount;
        this.actDataTotal[3].val = totalModel.winningPeopleCount;
        this.actDataTotal[4].val = totalModel.sendCount;
        this.settings.labelMap = {
          rankingSeqNum: "日期",
          sendCount: "奖品发放数量",
          winningCount: "中奖数量"
        };

        this.chartData = {
          columns: ["rankingSeqNum", "sendCount", "winningCount"],
          rows: detailEchartsList
        };
      } else if (this.searchCondition.gameType === "seckill") {
        //秒杀
      } else if (this.searchCondition.gameType === "bargain") {
        //砍价
        this.actDataTotal[0].val = totalModel.toTheLowerPriceCount;
        this.actDataTotal[1].val = totalModel.notToLowerPriceCount;
        this.actDataTotal[2].val = totalModel.participationInNoPurchaseCount;
        this.settings.labelMap = {
          goodsName: "活动名称",
          toTheLowerPriceCount: "砍到底价购买数",
          notToLowerPriceCount: "未砍到底价购买数",
          participationInNoPurchaseCount: "参与砍价未购买数"
        };
        this.chartData = {
          columns: [
            "goodsName",
            "toTheLowerPriceCount",
            "notToLowerPriceCount",
            "participationInNoPurchaseCount"
          ],
          rows: detailEchartsList
        };
      } else if (this.searchCondition.gameType.includes("_team")) {
        //拼团活动
        this.actDataTotal[0].val = totalModel.successCount;
        this.actDataTotal[1].val = totalModel.awaitCount;
        this.actDataTotal[2].val = totalModel.errorCount;
        this.settings.labelMap = {
          goodsName: "活动名称",
          successCount: "已成团数",
          awaitCount: "待成团数",
          errorCount: "拼团失败数"
        };
        this.chartData = {
          columns: ["goodsName", "successCount", "awaitCount", "errorCount"],
          rows: detailEchartsList
        };
      } else if (this.searchCondition.gameType === "subscribe") {
        //预约活动
        this.actDataTotal[0].val = totalModel.subscribeCount;
        this.actDataTotal[1].val = totalModel.presentCount;
        this.actDataTotal[2].val = totalModel.shareSubscribeCount;
        this.settings.labelMap = {
          actSite: "场地",
          presentCount: "到场数",
          shareSubscribeCount: "通过分享预约数",
          subscribeCount: "预约数"
        };
        detailEchartsList.forEach(v => {
          v.roundList.forEach(item => {
            item.actSite = "场次:" + item.actSite;
          });
          v.chartData = {
            columns: [
              "actSite",
              "presentCount",
              "shareSubscribeCount",
              "subscribeCount"
            ],
            rows: v.roundList
          };
        });
        this.subscribeDetailEchartsList = detailEchartsList;
        setTimeout(() => {
          this.handleScroll();
        }, 100);
      }
      let row = this.gameNameList.filter(
        v => v.gameId === this.searchCondition.gameId
      );
      if (this.searchCondition.gameType === "subscribe") {
        this.disabledStartDate = row[0].applyStartTime;
        this.disabledEndDate = row[0].applyEndTime;
        this.searchCondition.applyDate = [
          row[0].applyStartTime,
          row[0].applyEndTime
        ];
        this.dataAnalysis = [
          row[0].applyStartTime,
          row[0].applyEndTime
        ];
        this.dataPathAnalysis = [
          row[0].applyStartTime,
          row[0].applyEndTime
        ];
      } else {
        this.disabledStartDate = row[0].gameStartTime;
        this.disabledEndDate = row[0].gameEndTime;
        this.searchCondition.applyDate = [
          row[0].gameStartTime,
          row[0].gameEndTime
        ];
        this.dataAnalysis = [
          row[0].gameStartTime,
          row[0].gameEndTime
        ];
        this.dataPathAnalysis = [
          row[0].gameStartTime,
          row[0].gameEndTime
        ];
      }

      this.queryGameDataTotalEcharts();
      this.queryGameDataAnalyse();
      this.queryGameDataAnalysePath();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryGameDataTotalEcharts() {
      if (this.isArray(this.searchCondition.applyDate)) {
        let params = {
          queryStartTime:
            this.searchCondition.applyDate &&
            this.searchCondition.applyDate.length > 0
              ? this.searchCondition.applyDate[0]
              : "",
          queryEndTime:
            this.searchCondition.applyDate &&
            this.searchCondition.applyDate.length > 0
              ? this.searchCondition.applyDate[1]
              : "",
          gameId: this.searchCondition.gameId,
          gameType: this.searchCondition.gameType
        };
        const { result } = await this.$store.dispatch(
          "queryGameDataTotalEcharts",
          params
        );
        if (this.searchCondition.gameType === "turntable") {
          this.settingsLine.labelMap = {
            timeQuantum: "时间",
            joinCount: "参与次数",
            sendCount: "奖品发放数量",
            winningCount: "中奖数量"
          };
          if (result.length) {
            this.extendLine.title = false;
            // this.showEmpyt = false;
          }
          this.chartDataLine = {
            columns: ["timeQuantum", "joinCount", "sendCount", "winningCount"],
            rows: result
          };
        } else if (this.searchCondition.gameType === "seckill") {
          //秒杀
        } else if (this.searchCondition.gameType === "bargain") {
          //砍价
          this.settingsLine.labelMap = {
            timeQuantum: "时间",
            createOrderCount: "生成订单数"
          };
          this.chartDataLine = {
            columns: ["timeQuantum", "createOrderCount"],
            rows: result
          };
        } else if (this.searchCondition.gameType.includes("_team")) {
          //拼团活动
          this.settingsLine.labelMap = {
            timeQuantum: "时间",
            successCount: "拼团成功数"
          };
          this.chartDataLine = {
            columns: ["timeQuantum", "successCount"],
            rows: result
          };
        } else if (this.searchCondition.gameType === "subscribe") {
          //预约活动
          this.settingsLine.labelMap = {
            timeQuantum: "时间",
            subscribeCount: "预约数"
          };
          this.chartDataLine = {
            columns: ["timeQuantum", "subscribeCount"],
            rows: result
          };
        }
      } else {
        this.$message({
          message: "请选择时间段",
          type: "warning"
        });
      }
    },

    async queryGameDataAnalyse() {
      if (this.isArray(this.dataAnalysis)) {
        let params = {
          queryStartTime:
              this.dataAnalysis &&
              this.dataAnalysis.length > 0
                  ? this.dataAnalysis[0]
                  : "",
          queryEndTime:
              this.dataAnalysis &&
              this.dataAnalysis.length > 0
                  ? this.dataAnalysis[1]
                  : "",
          gameId: this.searchCondition.gameId,
          gameType: this.searchCondition.gameType
        };
        const { result } = await this.$store.dispatch(
            "queryGameDataAnalyse",
            params
        );
        const { echarts, statistics } = result;
        this.statisticsLineTitleData[0].val = statistics.spuVisitUv;
        this.statisticsLineTitleData[1].val = statistics.visitPv;
        this.statisticsChartsData.rows = echarts;
        console.log(result);
      } else {
        this.$message({
          message: "请选择时间段",
          type: "warning"
        });
      }
    },

    async queryGameDataAnalysePath() {
      if (this.isArray(this.dataAnalysis)) {
        let params = {
          queryStartTime:
              this.dataPathAnalysis &&
              this.dataPathAnalysis.length > 0
                  ? this.dataPathAnalysis[0]
                  : "",
          queryEndTime:
              this.dataPathAnalysis &&
              this.dataPathAnalysis.length > 0
                  ? this.dataPathAnalysis[1]
                  : "",
          gameId: this.searchCondition.gameId,
          gameType: this.searchCondition.gameType
        };
        const { result } = await this.$store.dispatch(
            "queryGameDataAnalysePath",
            params
        );
        this.trafficList = result;
        console.log(this.trafficList);

      } else {
        this.$message({
          message: "请选择时间段",
          type: "warning"
        });
      }
    },

    async findStoreGameInfoToGameData() {
      const { result } = await this.$store.dispatch(
        "findStoreGameInfoToGameData",
        {
          gameType: this.searchCondition.gameType
        }
      );
      if (this.searchCondition.gameType === "subscribe") {
        result.forEach(v => {
          v.gameName = v.actName;
          v.gameId = v.id;
        });
      }
      this.gameNameList = result;
      this.searchCondition.gameId = result[0].gameId;

      this.queryActInfo();

      return result;
    },
    async queryGameTypeList() {
      const { result } = await this.$store.dispatch("findStoreGameToGameData");
      this.gameTypeList = result;
    },
    handleScroll() {
      let scrollbarEl = this.$refs.scrollbar.wrap;
      scrollbarEl.onscroll = () => {
        if (scrollbarEl.scrollTop > 0) {
          this.isShowTip = false;
        } else {
          this.isShowTip = true;
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.act-data {
  background: #ffffff;
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  white-space: nowrap;
}
.img {
  width: 66px;
  img {
    width: 100%;
  }
}
.val {
  font-size: 24px;
  font-weight: bold;
}
.bg {
  background: #ffffff;
  padding: 10px;
}
.title {
  // margin-bottom: 20px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.is-showtip {
  font-size: 12px;
  div {
    transform: rotate(90deg);
    margin-top: 3px;
  }
}
.line-title {
  width: 156px;
  height: 76px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  margin-right: 30px;
  .line-border {
    width: 4px;
    height: 76px;
    border-radius: 6px 0px 0px 6px;
  }
  .uv-border {
    background: #43CDB7;
  }
  .pv-border {
    background: #B33AF7;
  }
  .title-style {
    font-size: 14px;
    color: #222222;
    margin-right: 6px;
  }
  .val-style {
    margin-top: 10px;
    font-size: 20px;
    color: #222222;
    font-weight: 600;
  }
}
.box {
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
  border-radius: 6px;
  padding: 20px;
  .yuan {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: #feeef5;
    text-align: center;
    line-height: 66px;
    margin-right: 20px;
    .hmicon {
      color: #e50065;
      font-size: 30px;
    }
  }
  .name {
    color: #222222;
    font-size: 14px;
  }
  .content {
    font-weight: 600;
    color: #222222;
    font-size: 15px;
    // white-space: nowrap;
  }
}
</style>
